export default __webpack_public_path__ + "static/media/facebook.1e46937b.svg";